export const ERROR_MESSAGE =
  'Oops! Something went wrong - please try again in a few minutes. If the issue persists, try logging out and back in again.'
